import { SignJWT } from "jose";

const METABASE_SITE_URL = process.env.REACT_APP_METABASE_SITE_URL;
const METABASE_SECRET_KEY = process.env.REACT_APP_METABASE_SECRET_KEY as string;

const TOKEN_EXPIRY_SECONDS = 2 * 60 * 60; // 2 hours

export async function generateMetabaseEmbedUrl(
  dashboardId: number,
): Promise<string> {
  const payload = {
    resource: { dashboard: dashboardId },
    params: {},
    exp: Math.round(Date.now() / 1000) + TOKEN_EXPIRY_SECONDS,
  };

  const secretKey = new TextEncoder().encode(METABASE_SECRET_KEY);

  const token = await new SignJWT(payload)
    .setProtectedHeader({ alg: "HS256" })
    .setIssuedAt()
    .sign(secretKey);

  return `${METABASE_SITE_URL}/embed/dashboard/${token}#bordered=false&titled=false`;
}
